import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import heartbeatApi from '../../services/api/HeartbeatApi';
import { ActivityMonitorConstants } from './services/ActivityMonitorConsts'
import { TokenValidationConstants } from './services/TokenValidationConsts'
import auth from '../../services/auth/AuthProvider';
import './ActivityMonitor.scss'
import ActivityMonitorContent from './ActivityMonitorContent'
import BaseModal from '../modal/BaseModal'

class ActivityMonitor extends Component {
    constructor(props) {
        super(props);

        // hook up all the events that should reset the last activity time
        window.onload = () => { this.resetActivity() }
        window.onmousemove = () => { this.resetActivity() }
        window.onkeypress = () => { this.resetActivity() }
        window.onmousedown = () => { this.resetActivity() }
        window.onscroll = () => { this.resetActivity() }
        window.onclick = () => { this.resetActivity() }

        this.activityState = {
            lastActivityTime: new Date().getTime()
        }

        this.tokenState = {
            lastHeartbeatCheck: new Date().getTime(),
            checkingHeartbeat: false,
            refreshingToken: false
        }

        this.state = {
            showingWarning: false
        }

        this.timerInterval = null;
    }

    componentWillMount() {
        this.activityState.lastActivityTime = new Date().getTime()
        if (auth.isAuthenticated()) {
            this.timerInterval = setInterval(this.processInterval, ActivityMonitorConstants.ACTIVITY_CHECK_INTERVAL_SECONDS * 1000)
        }
    }

    componentWillUnmount() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval)
            this.timerInterval = null
        }
    }

    // We're going to do three things here:
    // 1 - check to see whether to show the inactivity timer
    // 2 - check to see whether our token is close to expiry
    // 3 - validate whether our token has been revoked by hitting the heartbeat endpoint
    processInterval = () => {
        var timeSinceActivity = new Date().getTime() - this.activityState.lastActivityTime

        if (!this.state.showingWarning && timeSinceActivity > ActivityMonitorConstants.ACTIVITY_TIME_TO_WARNING_SECONDS * 1000) {
            this.setState({ showingWarning: true })
        }

        if (!this.tokenState.refreshingToken && auth.getTokenTimeToLive() < TokenValidationConstants.TOKEN_REFRESH_TIME_REMAINING_SECONDS * 1000) {
            this.tokenState.refreshingToken = true;
            auth.silentAuthentication(() => {
                return {
                    language: this.props.lang || 'en'
                }
            });
        }


        if (!this.tokenState.checkingHeartbeat && new Date().getTime() - this.tokenState.lastHeartbeatCheck > TokenValidationConstants.TOKEN_HEARTBEAT_INTERVAL_SECONDS * 1000) {
            this.tokenState.checkingHeartbeat = true
            heartbeatApi.get().then(
                (response) => {
                    this.tokenState.lastHeartbeatCheck = new Date().getTime()
                    this.tokenState.checkingHeartbeat = false
                },
                (error) => {
                    // our 401 / 403 interceptor will fix this issue
                    // if it comes back as an invalid token
                    this.tokenState.checkingHeartbeat = false
                }
            );
        }
    }

    resetActivity = () => {
        this.activityState.lastActivityTime = new Date().getTime();
    }

    stayLoggedIn = () => {
        this.resetActivity()
        this.setState({ showingWarning: false })
    }

    logout = () => {
        auth.logout();
    }

    render() {
        return (
            <BaseModal show={this.state.showingWarning} hideHeader={true} isNarrow={true}>
                <ActivityMonitorContent started={this.state.showingWarning} onStaySignedIn={this.stayLoggedIn}  />
            </BaseModal>
        )
    }
}

ActivityMonitor.propTypes = {
    lang: PropTypes.string
};

export default ActivityMonitor;
